import React, {Component} from 'react';

import toastr from "toastr";
import axios from "axios";
import update from 'immutability-helper';
import http from "../../services/httpService";
import {getCurrentUserName, setCurrentUserName, getCurrentUserId, getJwt} from "../../services/authService";
import NoFeeds from './feed/NoFeeds'
import WindowExpiredModal from "../modals/WindowExpiredModal";
import countries from "../common/countries";
import WebPushCustomPostModal from "../modals/WebPushCustomPostModal";

import authService from "../../services/authService";
// import ReactGA from "react-ga";
import {MenuItem, Tag, Switch, Tooltip, Position, Callout} from "@blueprintjs/core";
import {NavLink} from "react-router-dom";
import {MultiSelect} from "@blueprintjs/select";
import UpsellModal from "../modals/UpsellModal";
import PaymentMethodMissingModal from "../modals/PaymentMethodMissingModal";
import PaymentMethodExpiredModal from "../modals/PaymentMethodExpiredModal";
import PaymentMissingModal from "../modals/PaymentMissingModal";
import UpsellModalTailwind from "../modals/UpsellModalTailwind";


class WebPushCustomPost extends Component {
    state = {
        isEditing: false,
        message: [],
        saving: false,
        notifications: [],
        selectedOption: {
            value: "", label: "Please select page..."
        },
        selectedRadioOption: 'all',
        title: '',
        link: '',
        get_title_from_url: true,
        countPushSubscribers: '',
        postStats: [],
        post_count_by_channel: [],
        count_type_subscrib: "all",
        showSingle: true,
        imageFromLink: "",
        selectedSource: this.props.selectedSource,
        selectedSourceFull: [],
        loading: 0,
        freeMessages: '',
        loading_title: false,
        stopBroadcastModal: false,
        characterCount: 0,
        messageContent: '',
        emojiOpen: false,
        showMessage: false,
        subsFilter: 'all-subs',
        genderFilter: 'all-genders',
        native: false,
        invalidLink: false,
        windowModalActive: false,
        windowSentTo: 0,
        sendToAll: true,
        selectedCountries: [],
        selectedPhones: [],
        projectPayment: '',
        selectedWhen: 'Immediately',
        selectedTags: [],
        enableTags: false,
        webPushCustomPostModal: false,
        upgradeModalActive: false,
        upgradeModalTitle: '',
        upgradeModalContent: '',
        sourcePlan: 'free_plan',
        errorsList: [],
        postDescription: '',
        postUrl: '',
        error: '',
        currentPlanLimitations: this.props.currentPlanLimitations ? this.props.currentPlanLimitations : '',
        user: this.props.user,
        paymentMethodModal: false,
        paymentMethodExpiredModal: false,
        currentDate: '',
        cardExpired: false,
        rerunData: '',
    };


    componentDidMount = () => {
        //console.log('cdm run')
        this.getUserBilling()
        //console.log('entered component did mount ');
        // ReactGA.pageview(window.location.pathname + window.location.search);
        //console.log('selected source id: ', this.props.selectedSource);
        //console.log('cdm - currentPlanLimitations: ', this.state.currentPlanLimitations)

        let selectedSource = this.props.user.sources.data.filter(source => source.id.toString() === this.props.selectedSource)

        let selectedSourceFull = this.state.user.sources.data.filter(source => {
            // //console.log('current source Id : ', source.id)
            // //console.log('selectedSource id :', this.state.selectedSource);
            return source.id.toString() === this.state.selectedSource.toString()

        })
        this.setState({
            selectedSourceFull
        })
        //console.log('selectedSource full: ', selectedSource)
        if (selectedSource[0]) {

            //collecting remaining free messages
            let webpushPlatform = selectedSource[0].platforms.filter(platform => platform.platform === 'wp')
            //console.log('webpush platform :', webpushPlatform);


            this.setState({
                sourcePlan: selectedSource[0] ? selectedSource[0].platforms[0].plan : '',
                freeMessages: webpushPlatform[0] ? webpushPlatform[0].free_messages_remaining : this.state.freeMessages
            })
        }
        let today = new Date();
        let dateFormat = [today.getFullYear(), today.getMonth() + 1, //  today.getDate()
        ].join('-')
        this.setState({
            currentDate: dateFormat
        })


        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
        //hiding emoji picker when clicked around
        //console.log('this.props.location: ', this.props.location)
        const postDataPassed = this.props.location.state ? this.props.location.state.post : '';
        if (postDataPassed && postDataPassed.short_url) {
            //console.log('entered function: ', postDataPassed)


            this.setState({
                link: postDataPassed.short_url,

            })

            this.getLinkData(postDataPassed.short_url)
        }
        setCurrentUserName(this.props.user.name);

        if (this.props.location.state) {
            if (this.props.location.state.id) {
                let rerunData = this.props.location.state
                //console.log('webpush rerunData: ', rerunData)
                let link = rerunData.link.substring(0, rerunData.link.indexOf('?'));

                // console.info('cdm - rerunTags: ', rerunTags)
                // console.info('cdm - message_html: ', rerunData.message_html)

                let selectedTags = []
                let selectedTagIds = []
                let allTags = this.props.tags
                let existingTag = ''
                let sendToAll = true
                if (rerunData.data.tags_wp) {
                    if (rerunData.data.tags_wp.length !== 0) {
                        sendToAll = false
                        let rerunTags = rerunData.data.tags_wp
                        rerunTags.forEach((el, i) => {
                            //console.info('entered loop')

                            existingTag = allTags.filter(tag => {
                                return tag.tag === el
                            })


                            //console.info('existingTag: ', existingTag)
                            // let filteredTag = existingTag.filter(function (el) {
                            //     return el != null;
                            // });
                            // console.log('filteredTag: ', filteredTag)
                            if (existingTag.length !== 0) {
                                selectedTags.push(existingTag[0])
                                selectedTagIds.push(existingTag[0].id)
                            }
                            sendToAll = false
                        })
                    }
                }

                this.setState({
                    rerunData, link: link, sendToAll, selectedTags
                })

                this.getLinkData()
            }
        }
    }


    componentDidUpdate = async () => {
        if (this.state.selectedSource !== this.props.selectedSource) {

            this.getUserBilling()

            let selectedSourceFull = this.state.user.sources.data.filter(source => {
                // //console.log('current source Id : ', source.id)
                // //console.log('selectedSource id :', this.state.selectedSource);
                return source.id.toString() === this.props.selectedSource.toString()

            })

            if (selectedSourceFull[0]) {
                const postDataPassed = this.props.location.state ? this.props.location.state.post : '';
                if (postDataPassed && postDataPassed.short_url) {
                    // console.log('entered function: ', postDataPassed)


                    await this.setState({
                        link: postDataPassed.short_url,

                    })

                    await this.getLinkData()

                }
            }
            this.setState({
                currentPlanLimitations: this.props.currentPlanLimitations,
                selectedSource: this.props.selectedSource,
                selectedSourceFull
            })
        }

    }

    validURL = (str) => {
        let pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }

    multiMenuItem = (item, {modifiers, handleClick}) => {
        if (this.state.selectedTags.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}

                    shouldDismissPopover={true}
                />)
        } else {
            return (<MenuItem
                className='multiselect-menu-item '
                icon='small-tick'
                active={modifiers.active}
                key={item.id}
                label=''
                text={item.tag}
                onClick={handleClick}
                shouldDismissPopover={true}
            />)
        }
    };

    handleTagRemove = async (item) => {
        const selectedTags = this.state.selectedTags;
        const newTags = await selectedTags.filter(t => t.tag !== item.props.children);
        await this.setState({selectedTags: newTags});
    };

    tagSelect = (item) => {
        // console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;
        // console.log('selectedTags beginning: ', selectedTags);

        if (selectedTags.includes(item) === false) {

            // console.log('adding new tag: ', item);

            selectedTags.push(item);
            this.setState({selectedTags: selectedTags});
        } else {

            // console.log('removing tag: ', item)
            const newTags = selectedTags.filter(t => t !== item);
            this.setState({selectedTags: newTags})
        }

    };

    tagRender = (item) => {
        //console.log('rendering tag: ', item);
        return (<Tag key={item.id}>{item.tag}</Tag>)
    };

    toggleSendToAll = () => {
        let sendToAll = !this.state.sendToAll;
        let selectedTags = this.state.selectedTags;
        if (sendToAll === false) {
            selectedTags = []
        }
        //console.log('enable tags:', enableTags);

        this.setState({sendToAll, selectedTags})
    }

    sendWebPushNotification = async (title, link) => {

        //console.log('sending webpush notification');
        toastr.info("Sending your post in progress...")
        await this.setState({
            loading: 1
        })

        let platforms_enabled = this.props.platforms_enabled;
        let tagSegmentation = 0;
        let tagIds = [];
        if (this.state.sourcePlan === 'free_plan') {
            tagSegmentation = 0;
        } else {
            if (this.state.sendToAll === true) {
                tagSegmentation = 0
            } else {
                if (this.state.selectedTags !== []) {
                    tagSegmentation = 1;
                    this.state.selectedTags.map(tag => {
                        tagIds = [...tagIds, tag.id]
                    })
                }
            }
        }
        let webpush_platform_enabled = platforms_enabled && platforms_enabled.indexOf("wp") > -1;
        let notification = {
            notification_title: title, notification_link: link, tag_segmentation: tagSegmentation, tag_ids: tagIds
        };
        //console.log('webpush notification parameters: ', notification)

        if (webpush_platform_enabled) {
            try {
                this.props.loadingSubscribers(true);

                //console.log('webpush call: ', 'api/send-custom -notification/' + getCurrentUserId() + '/feed/' + this.props.selectedSource)
                const res_push = await http.post('api/send-custom-notification/' + getCurrentUserId() + '/feed/' + this.props.selectedSource, notification, {headers: {authorization: getJwt()}});

                // console.log('res_push: ', res_push)
                //console.log('webpush custom response: ', res_push)
                let freeMessages = res_push.data.count || res_push.data.count === 0 ? this.state.freeMessages - res_push.data.count : res_push.data.remaining_credits

                //console.log('freeMessages: ', freeMessages);
                this.setState({
                    error: res_push.data.error ? res_push.data.error : '',
                    countPushSubscribers: res_push.data.count,
                    freeMessages: freeMessages
                });


                await this.setState({
                    webPushCustomPostModal: true, loading: 0
                });

                //loading subscribers count for 2.6 seconds
                // setTimeout(function () {
                //     this.state.loadingSubscribers(false);
                // }, 2600)
            } catch (ex) {
                if (ex.response && ex.response.status === 404) {
                    toastr.error("Error Code #17035: Push notifications for this website are not set up!");
                    this.setState({
                        loading: 0
                    })
                    const broadcast_click = {
                        target: {
                            id: "broadcastClick"
                        }
                    };

                    const data = {
                        postStats: this.state.post_count_by_channel, type: 'web_push_notification'
                    };

                    // if ( !this.state.stopBroadcastModal ) {
                    this.props.openModal(broadcast_click, data || 0);
                    // }
                }
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }
    };
    setSubsZero = () => {
        this.setState({
            countPushSubscribers: 0
        })
    }

    broadcastClick = async (e, selectedTags) => {

        let invalidLinkError = false;


        if (this.state.invalidLink === true) {
            toastr.error('Provided link seems to be invalid.')
            invalidLinkError = true

        }


        if (invalidLinkError === false) {
            //console.log('selected tags:', selectedTags);


            const {title, link} = this.state;

            if (title && link) {
                //console.log('should be changing now');


                await this.sendWebPushNotification(title, link);

            } else {
                toastr.error("Both 'Title' and 'Link' fields are required");
            }


        }
    };

    isValidUrl = (userInput) => {
        //console.log('userInput: ', userInput)
        //console.log('isValidUrl activated');
        let res = userInput.target.value.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        return res != null;
    }

    getLinkData = async (index = null, value = null, link = null) => {
        // console.log('getLinkData')
        // console.log('value:', value);
        // console.log('link: ', link);
        // console.log('index:', index)

        if (this.state.link !== '') {
           // console.log('this.state.link: ', this.state.link)
            let validLink = await this.isValidUrl(index ?? this.state.link)

            // console.log('validLink: ', validLink)
            if (validLink === true) {

               // console.log('link is valid')
                this.setState({
                    loading_title: true
                });


                let URL_META = this.state.link;
                let n = URL_META.startsWith('http');
                //console.log('value:', URL_META);
                //console.log('n:', n);
                if (n === false) {
                    URL_META = 'http://' + URL_META
                    this.setState({link: URL_META});
                }

                try {
                    const result = await http.post('/api/url_metadata', {
                        'url': URL_META
                    }, {headers: {authorization: getJwt()}});

                    //console.log('getLinkData fetchResult: ', result)

                    if (result.status === 200) {

                       // console.log('result.status is 200')


                        await this.setState({
                            invalidLink: false,
                            imageFromLink: result.data.image ? result.data.image : "/img/no-photo-found.jpeg",
                            postDescription: result.data.description,
                            postUrl: this.state.link
                        });


                        if (this.state.get_title_from_url === true) {
                            await this.setState({
                                title: result.data.title ? result.data.title : ''
                            });
                        }


                    } else {
                        toastr.error("It appears that the link isn't pointing to a valid website!")

                        //console.log(loadingTitle);
                        // console.log('index on blur:', index);

                        await this.setState({
                            invalidLink: true, loading_title: false,

                        })


                    }


                } catch (e) {
                    // console.log(e)
                    toastr.error("We can't currently fetch the link's metadata. Please try again in a few minutes.");
                }


                this.setState({
                    loading_title: false
                });
            } else {
                //toastr.error('Please provide a valid link')
            }
        }
    };

    countryMenuItem = (item, {modifiers, handleClick}) => {
        if (this.state.selectedCountries.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.name}
                    label=''
                    text={item.name + ' ' + '(' + item.code + ')' + ' ' + item.flag}
                    onClick={handleClick}
                    query=''
                    shouldDismissPopover={true}

                />)
        } else {
            return (<MenuItem
                className='multiselect-menu-item'
                icon='small-tick'
                active={modifiers.active}
                key={item.name}
                label=''
                text={item.name + ' ' + '(' + item.code + ')' + ' ' + item.flag}
                onClick={handleClick}
                shouldDismissPopover={true}
            />)
        }
    };

    handleCountryRemove = async (item) => {

        //console.log('country item: ', item);

        const selectedCountries = this.state.selectedCountries;
        const selectedPhones = this.state.selectedPhones;

        //console.log('selectedCountries :', selectedCountries)
        const newCountries = await selectedCountries.filter(c => c.name !== item.key);
        const newPhones = await selectedPhones.filter(p => p.dial_code !== item.dial_code)
        //console.log('newCountries :', newCountries)
        await this.setState({selectedCountries: newCountries, selectedPhones: newPhones})

    };

    countrySelect = async (item) => {
        //console.log('selected country: ', item);
        let selectedCountries = this.state.selectedCountries;

        let selectedPhones = this.state.selectedPhones;
        //console.log('selected tags ids:', selectedTagsIds);
        if (selectedCountries.includes(item) === false) {
            selectedPhones.push(item.dial_code);
            selectedCountries.push(item);
            await this.setState({selectedCountries, selectedPhones});
        } else {
            let newCountries = await selectedCountries.filter(t => t !== item);
            let newPhones = await selectedPhones.filter(p => p.dial_code !== item.dial_code);
            await this.setState({selectedCountries: newCountries, selectedPhones: newPhones})
        }
    };

    filterCountries = (item) => {

        //console.log(' country filter item:', item);

        return countries.filter((c) => {
            return c.name.toLowerCase().includes(item.toLowerCase());
        });
    };

    countryRender = (item) => {

        //console.log('flags :', this.state.flags[code]);
        //sets country code to lowercase

        return (<Tag key={item.name}>
            <span style={{marginRight: 8}}>{item.flag}</span>
            {item.code}
        </Tag>)

    };

    getUserBilling = async () => {
        //console.log('this.props.selectedSource: ', this.props.selectedSource)
        //console.log('curentUserId: ', getCurrentUserId())
        //console.log('user: ', this.props.user)

        if (this.state.selectedSource !== '') {
            try {
                //console.log('billing call: ', '/api/user/' + getCurrentUserId() + '/project/' + this.props.selectedSource + '/customers/get_payment_methods_project')
                const billingResult = await http.get('/api/user/' + getCurrentUserId() + '/project/' + this.props.selectedSource + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                // console.log('billing call result: ', billingResult)
                let defaultPayment = billingResult.data.project_payment_methods.find(payment => payment.project_default === 1);
                this.setState({
                    projectPayment: billingResult.data.project_payment_methods[0] ? defaultPayment : '',
                })
            } catch (e) {
                toastr.error('Something went wrong... Please try again.')
            }
        }
    }

    showPaymentModal = async () => {
        // console.log('showPaymentModal')
        await this.setState({paymentMethodModal: true})
    }

    showPaymentExpiredModal = async () => {
        // console.log('showPaymentExpiredModal')
        // console.log('showPaymentModal')
        await this.setState({paymentMethodModal: true})
    }

    limitReached = async () => {
        //console.log('limitReacthed activated')
        if (this.state.sourcePlan === 'free_plan') {
            this.setState({
                upgradeModalActive: true,
                upgradeModalTitle: 'Wow! Your business is growing!',
                upgradeModalContent: <div className='upsell-content'>
                    <p className='flag-text'>
                        <span><i className="fas fa-flag"></i> Youâ€™ve</span> reached
                        your <span>30.000 Web Push Notifications</span> limit
                        for this month. </p>
                    <p className='upgrade-text'><span>Upgrade</span> for more Web Push Notifications and awesome
                        additional features!</p>
                </div>
            })
        } else {
            this.setState({
                upgradeModalActive: true,
                upgradeModalTitle: 'WebPush 60.000 limit reached',
                upgradeModalContent: 'You have now spent all of your included WebPush credits. ' + 'From now on you will be charged $2.5 per 1.000 WP notifications. You will receive next bundle of 60.000 WP notifications next month.'

            })
        }
    }

    upgradeToProFeature = () => {
        //console.log('upgradeToProFeature')
        this.setState({
            upgradeModalActive: true,
            upgradeModalTitle: 'Segmentation is not available on your current plan.',
            upgradeModalContent: `<p>Check out the plans and features below and choose one that suits your needs.<br>
                Our team is available from the chat if you need any assistance.</p>`
        })
    }

    handleGetTitleFromUrl = () => {

        if (this.state.get_title_from_url) {
            this.setState({
                title: ""
            });
        }
        this.setState({
            get_title_from_url: !this.state.get_title_from_url
        });

    };

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
    }

    openUpgradeModal = () => {
        this.setState({
            upgradeModalActive: true, upgradeModalTitle: '', upgradeModalContent: ''
        })
    }


    render() {
        const sources = this.props.sources || {};
        const selected_src_id = this.props.selectedSource || "";

        if (!selected_src_id) {
            return <React.Fragment>
                <h1 className='main-title'>Webpush</h1>
                <p className="nav-back" onClick={() => this.props.history.push('/new')}><i
                    className="fas fa-chevron-left"></i> New Campaign</p>
                {sources.length ? <div className="row">
                    <div className="col-xs-12 text-center no-feeds-containers">
                        <div className="feed-msg">
                            <img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                            <p className="text-center ">{authService.getCurrentUserName()}</p>
                            <p>It looks like you haven't set up any workspaces yet. Add your first
                                workspace,
                                and
                                start growing your audience.</p>
                            <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/>
                        </div>
                        <button className='btn-m btn-action' onClick={this.props.addSource} type="button">
                            Create your first workspace
                        </button>
                    </div>
                </div> : <NoFeeds userFullName={this.props.userFullName}/>}

            </React.Fragment>
        }

        let webpush_platform_enabled = this.props.platforms_enabled && this.props.platforms_enabled.indexOf("wp") > -1;

        return <React.Fragment>
            <h1 className='main-title'>Webpush</h1>
            <p className="nav-back" onClick={() => this.props.history.push('/new')}><i
                className="fas fa-chevron-left"></i> New Campaign</p>

            <div id="single-post" className="d-block panel-container campaign-container">
                {this.state.freeMessages === 0 ? <Callout
                    intent='primary'
                    icon='info-sign'
                >There are no free Web Push notifications left. You will be charged for your campaign at the
                    <span
                        className='text-bold'> $ {this.state.selectedSourceFull[0].plan.platform_limits.wp.price / 1000}</span> per
                    notification.
                </Callout> : ''}
                <p className='text-bold custom-subtitle'>Message</p>

                <div className="flex-row justify-content-space posts-columns flex-wrap">
                    <div className="half-width">
                        <div className="section m-lg-b">


                            <div className="form-group m-k-b">


                                <p className='full-row-label'>Post Link</p>
                                <input
                                    className={this.state.link === '' ? 'fb-sponsored-message-input' : 'fb-sponsored-message-input valid'}
                                    id='post-link'
                                    placeholder="http://example.com/post"
                                    value={this.state.link}
                                    type="text"
                                    onBlur={this.getLinkData}
                                    onChange={(e) => {
                                        this.setState({link: e.target.value})
                                    }}
                                />

                            </div>
                            <div className="form-group m-lg-b m-k-b">
                                <span className="label full-row-label">Post Title
                                    <label className="right">

                                        <Switch checked={this.state.get_title_from_url}
                                                label="Fetch the title from the link"
                                                onChange={this.handleGetTitleFromUrl}/>

                                    </label>
                                </span>
                                <input
                                    id='post-title'
                                    className={this.state.loading_title ? "fb-sponsored-message-input input-loading" : "fb-sponsored-message-input"}
                                    placeholder="You can use a fetched default, or change it to a custom title"
                                    type="text"
                                    value={this.state.title}
                                    onChange={(e) => {
                                        this.setState({title: e.target.value})
                                    }}/>
                            </div>
                        </div>
                        {!webpush_platform_enabled ? <div className="section send-to-all m-lg-b">
                            <p><span className="fas fa-envelope"
                                     data-placement="top"></span>
                                Send posts to
                            </p>
                            <div className="separator m-m-b"></div>
                            <span className="text-light-grey">To use this feature you must enable the
                                    distribution
                                    channels you want to use.
                                    You can do this on the <a href="/channels">Channels </a> page</span>
                        </div> : <React.Fragment>

                            <div className="space-between tag-toggle-container">
                                <p className='custom-subtitle text-bold'>
                                    Segments
                                </p>
                                <div className="details-trigger right">

                                    <Switch checked={this.state.sendToAll}
                                            label="Send to all"
                                            onChange={this.toggleSendToAll}/>

                                </div>
                            </div>

                            <div className="multiselect-container">
                                {this.state.sendToAll === false ? <React.Fragment>
                                    <label>Sent to audience with these tags</label>
                                    <MultiSelect
                                        items={this.props.tags}
                                        itemRenderer={this.multiMenuItem}
                                        tagInputProps={{
                                            placeholder: 'Filter by tag', onRemove: this.handleTagRemove
                                        }}
                                        resetOnSelect={true}

                                        className='tag-multiselect custom-posts-tag-filter'
                                        onItemSelect={this.tagSelect}
                                        tagRenderer={this.tagRender}
                                        itemListPredicate={this.props.filterTags}
                                        selectedItems={this.state.selectedTags}
                                        fill={true}
                                        noResults={<MenuItem disabled={true} text="No results."/>}
                                    />

                                    {/*<label>Send to specific country</label>*/}
                                    {/*<MultiSelect*/}
                                    {/*    items={countries}*/}
                                    {/*    itemRenderer={this.countryMenuItem}*/}
                                    {/*    tagInputProps={{*/}
                                    {/*        placeholder: 'Filter by country',*/}
                                    {/*        onRemove: this.handleCountryRemove*/}
                                    {/*    }}*/}
                                    {/*    filterable={true}*/}
                                    {/*    resetOnSelect={true}*/}
                                    {/*    className='tag-multiselect'*/}
                                    {/*    onItemSelect={this.countrySelect}*/}
                                    {/*    tagRenderer={this.countryRender}*/}
                                    {/*    itemListPredicate={this.filterCountries}*/}
                                    {/*    selectedItems={this.state.selectedCountries}*/}
                                    {/*    fill={true}*/}
                                    {/*    noResults={<MenuItem disabled={true} text="No results."/>}*/}
                                    {/*/>*/}

                                    {this.state.selectedSourceFull ? this.state.selectedSourceFull[0] ? this.state.selectedSourceFull[0].plan ? this.state.selectedSourceFull[0].plan.additional_features.tags_segmentation === 0 ?

                                        <Callout
                                            className='m-lg-t'
                                            intent='primary'
                                            icon='info-sign'
                                        >
                                            Top up your game. <span
                                            className='text-underline'>Pro plans only.</span>
                                            <a className='text-bold'
                                               onClick={this.upgradeToProFeature}
                                               href="#">Go PRO</a>
                                        </Callout> : '' : '' : '' : ''}
                                </React.Fragment> : ''}

                            </div>
                            <p className='custom-subtitle text-bold '>When to send</p>
                            <div
                                //onClick={this.handleWhen}
                                className='flex-direction-row when-to-send m-lg-b'
                            >
                                <Tooltip content="Coming Soon!" position={Position.BOTTOM}>
                                    <div
                                        className={this.state.selectedWhen === 'Schedule' ? "when-selection active" : 'when-selection disabled'}>

                                        Schedule

                                    </div>
                                </Tooltip>
                                <div
                                    className={this.state.selectedWhen === 'Immediately' ? "when-selection active" : 'when-selection'}>
                                    Immediately
                                </div>
                            </div>
                            <div className="flex-direction-row justify-content-space">

                                <button className='btn-white'
                                        onClick={() => this.props.history.push('/new')}>
                                    Cancel
                                </button>
                                <button id="broadcast_single" className="btn-action"
                                        onClick={this.state.selectedSourceFull ? this.state.selectedSourceFull[0] ? this.state.selectedSourceFull[0].plan ? this.state.selectedSourceFull[0].plan.additional_features.tags_segmentation === 0 ? this.state.sendToAll === false ? this.upgradeToProFeature : this.state.freeMessages === 0 ? !this.state.projectPayment ?

                                                this.showPaymentModal : this.state.cardExpired ? this.showPaymentExpiredModal

                                                    : (e) => this.broadcastClick(e, this.state.selectedTags) : (e) => this.broadcastClick(e, this.state.selectedTags)

                                            : this.state.freeMessages === 0 ? !this.state.projectPayment ? this.showPaymentModal : this.state.cardExpired ? this.showPaymentExpiredModal

                                                    : (e) => this.broadcastClick(e, this.state.selectedTags)

                                                : (e) => this.broadcastClick(e, this.state.selectedTags) : this.state.freeMessages === 0 ? this.state.cardExpired ? this.showPaymentExpiredModal

                                                : (e) => this.broadcastClick(e, this.state.selectedTags)

                                            : (e) => this.broadcastClick(e, this.state.selectedTags) : '' : ''

                                        }
                                        disabled={this.state.loading === 1 ? true : ''}>
                                    Broadcast Now {this.state.loading === 1 ?
                                    <i className='fa fa-spin fa-spinner'></i> : ""}
                                </button>
                            </div>
                        </React.Fragment>}

                    </div>

                    <div className="half-width">
                        <div className="section m-lg-b">
                            <p>
                                Preview
                            </p>
                            <div className="preview-screen webpush-preview">

                                {/*{ console.log('Props in CustomSinglePostPreview: ', props )}*/}
                                {/*<div className="preview-post">*/}
                                {/*    {*/}
                                {/*        this.state.loading_title ?*/}
                                {/*            <div className="loader" style={{margin: "10px 0 10px 15%"}}></div>*/}
                                {/*            :*/}
                                {/*            <div className="preview-post-picture post-picture-style"*/}
                                {/*                 style={{backgroundImage: "url(" + this.state.imageFromLink + ")"}}>*/}
                                {/*            </div>*/}
                                {/*    }*/}
                                {/*    <div className="preview-post-title">*/}
                                {/*        {this.state.title}*/}
                                {/*    </div>*/}
                                {/*    <div className="preview-post-button text-center">*/}
                                {/*        Read*/}
                                {/*    </div>*/}
                                {/*    <div className="preview-post-button text-center">*/}
                                {/*        Share*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                <div className="preview-container">
                                    <div className='flex-row max-width-70-percent'>
                                        <div className="favicon-container">
                                            <img src="/img/chrome-icon.png" alt="Chrome Favicon"/>
                                        </div>
                                        <div className="info-container">
                                            <p className='post-preview-title'>
                                                {this.state.title ? this.state.title.length > 20 ? this.state.title.substring(0, 20) + "..." : this.state.title : ''}
                                            </p>
                                            <p className='post-preview-url'>{this.state.postUrl}</p>
                                            <p className='post-preview-description'>{this.state.postDescription ? this.state.postDescription.length > 30 ? this.state.postDescription.substring(0, 30) + "..." : this.state.postDescription : ''}</p>
                                        </div>
                                    </div>
                                    <div className="post-preview-image-container">
                                        {this.state.imageFromLink ?
                                            <img src={this.state.imageFromLink} alt="Preview Image"/> : ''}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <WindowExpiredModal
                showModal={this.state.windowModalActive}
                handleClose={() => this.setState({windowModalActive: false})}
                maxWidth={500}
                history={this.props.history}
                sentTo={this.state.windowSentTo}
                setSubsZero={this.setSubsZero}
            />
            <WebPushCustomPostModal
                error={this.state.error}
                count_total_subscrib_sent={this.state.count_total_subscrib_sent}
                countPushSubscribers={this.state.countPushSubscribers}
                showModal={this.state.webPushCustomPostModal}
                handleClose={() => this.setState({webPushCustomPostModal: false})}
                maxWidth={500}
                history={this.props.history}
            />
            <UpsellModalTailwind
                showModal={this.state.upgradeModalActive}
                handleClose={() => this.setState({upgradeModalActive: false})}
                maxWidth={null}
                history={this.props.history}
                title={this.state.upgradeModalTitle}
                content={this.state.upgradeModalContent}
                plan={this.state.sourcePlan}
                user={this.props.user}
            />
            <PaymentMissingModal
                showModal={this.state.paymentMethodModal}
                handleClose={() => this.setState({paymentMissingModalActive: false})}
                maxWidth={null}
                history={this.props.history}
                title={<span> Youâ€™ve reached your free <br/> Web Push notifications limit</span>}
                content={<div className='text-center'>
                    <p className='flag-text'>
                        You've spent your 30.000 free
                        Web Push notifications.
                        To continue sending Facebook Messages, you need to add a default <a
                        href="/billing/payment-methods">payment
                        method.</a> for this workspace!
                    </p>
                    <p className='upgrade-text'>
                        You will be
                        charged <span
                        className='text-bold'>$ $0.9 per 1,000 notifications</span> (until your free
                        messages
                        recharge next month).</p>
                </div>}
                plan={this.state.sourcePlan}
                user={this.props.user}

            />
            <PaymentMethodExpiredModal
                showModal={this.state.paymentMethodExpiredModal}
                handleClose={() => this.setState({paymentMethodExpiredModal: false})}
                maxWidth={500}
                history={this.props.history}
            />
        </React.Fragment>
    }
}

export default WebPushCustomPost;
